module.exports = __webpack_public_path__ + "img/commission.a2819e80.svg";